// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入SDK
import '../static/js/mySdk.js';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)
//import './../static/js/jsSDK.js';
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  //render: h => h(App),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js